module.exports = __webpack_public_path__ + "static/img/advertising1.df0e3749.png";